import React, { useState } from "react";

const categoryMap = [
  {
    name: "Finance",
    isChecked: false,
  },
  {
    name: "Uncategorized",
    isChecked: false,
  },
  {
    name: "Adult Content",
    isChecked: false,
  },
  {
    name: "Language",
    isChecked: false,
  },
  {
    name: "Art & Design",
    isChecked: false,
  },
  {
    name: "Broadcasting",
    isChecked: false,
  },
  {
    name: "Politics",
    isChecked: false,
  },
  {
    name: "Sports",
    isChecked: false,
  },
  {
    name: "Food & Nutrition",
    isChecked: false,
  },
  {
    name: "Style & Beauty",
    isChecked: false,
  },
  {
    name: "Home & Gardening",
    isChecked: false,
  },
  {
    name: "Engineering",
    isChecked: false,
  },
  {
    name: "Post Secondary",
    isChecked: false,
  },
  {
    name: "Academics & Education",
    isChecked: false,
  },
  {
    name: "Music & Dance",
    isChecked: false,
  },
  {
    name: "Health & Fitness",
    isChecked: false,
  },
  {
    name: "Video & Photography",
    isChecked: false,
  },
  {
    name: "LifeStyle",
    isChecked: false,
  },
  {
    name: "Sales & Marketing",
    isChecked: false,
  },
  {
    name: "IT & Software",
    isChecked: false,
  },
  {
    name: "Development",
    isChecked: false,
  },
  {
    name: "Business",
    isChecked: false,
  },
];

const MultipleDropdown = ({ handleInputChange, formValues, setFormValues }) => {
  const [categoryData, setCategoryData] = useState(categoryMap);
  const [showMultipleCheckBox, setShowMultipleCheckBox] = useState(false);
  const [categorySelection, setCategorySelection] = useState([]);

  function showCheckboxes() {
    setShowMultipleCheckBox(!showMultipleCheckBox);
  }

  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    let clonedValues = [...formValues.multipleCheckBox];

    if (clonedValues.includes(value)) {
      let arr = clonedValues;
      arr.splice(arr.indexOf(value), 1);
      setCategorySelection(arr);
      setFormValues({ ...formValues, multipleCheckBox: arr });
    } else clonedValues.push(value);

    setFormValues({
      ...formValues,
      multipleCheckBox: clonedValues,
    });

    const tempChecked = categoryData.map((el) => {
      if (el.name === name) {
        return { ...el, isChecked: checked };
      } else return el;
    });
    setCategoryData(tempChecked);
  };

  return (
    <div className="category-container">
      <div class="">
        <div class="category-item" onClick={showCheckboxes}>
          <select>
            <option>Select an option</option>
          </select>
          <div class="overSelect"></div>
        </div>
        {showMultipleCheckBox && (
          <div className="custom-bundle-select">
            <div>
              {categoryData &&
                categoryData.slice(0, 11).map((allCategory, index) => {
                  return (
                    <div className="multibox-flex">
                      <input
                        type="checkbox"
                        name={allCategory.name}
                        value={allCategory.name}
                        id={index}
                        onChange={handleChange}
                        checked={allCategory.isChecked}
                      />
                      <label>{allCategory.name}</label>
                    </div>
                  );
                })}
            </div>
            <div>
              {categoryData &&
                categoryData.slice(11, 22).map((allCategory, index) => {
                  return (
                    <div className="multibox-flex">
                      <input
                        type="checkbox"
                        name={allCategory.name}
                        //         name="multipleCheckBox"
                        value={allCategory.name}
                        id={index}
                        onChange={handleChange}
                        checked={allCategory.isChecked}
                      />
                      <label>{allCategory.name}</label>
                    </div>
                  );
                })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MultipleDropdown;
